export const ActionTypes = {
  FETCH_REJECTION_OPERATIONS: 'services/rejectionOperation/fetch_rejection_operations',
  SET_REJECTION_OPERATIONS: 'services/rejectionOperation/set_rejection_operations',
  FETCH_OEE_DATES: 'services/rejectionOperation/fetch_oee_dates',
  SET_OEE_DATES: 'services/rejectionOperation/set_oee_dates',
  FETCH_OEE_HOURS: 'services/rejectionOperation/fetch_oee_hours',
  SET_OEE_HOURS: 'services/rejectionOperation/set_oee_hours',
  FETCH_OEE_SHIFTS: 'services/rejectionOperation/fetch_oee_shifts',
  SET_OEE_SHIFTS: 'services/rejectionOperation/set_oee_shifts',
  SET_REJECTION_OPERATIONS_LOADER_STATUS: 'services/rejectionOperation/set_rejection_operations_loader_status',
  ADD_UPDATE_REJECTION_OPERATION: 'services/rejectionOperation/add_update_rejection_operations',
  DELETE_REJECTION_OPERATION: 'services/rejectionOperation/delete_rejection_operations',
  ADD_JOB_REJECTION: 'services/rejectionOperation/add_job_rejection',
  ADD_JOB_HISTORY_REJECTION: 'services/rejectionOperation/add_job_history_rejection',
  ADD_JOB_HISTORY_PRODUCTION: 'services/rejectionOperation/add_job_history_production',

  SET_REJECTION_FILTER: 'services/rejectionOperation/set_rejection_filter',

  FETCH_SHIFT_REJECTION: 'services/rejectionOperation/fetch_shift_rejection',
  SET_SHIFT_REJECTION: 'services/rejectionOperation/set_shift_rejection',
  SET_JOB_REJECTION_CONFIRMATION_MODAL_DATA: 'services/dashboards/job/set_job_rejection_confirmation_modal_data',
};

const fetchRejectionOperations = ({ rejectionOperationsParams }) => ({
  rejectionOperationsParams,
  type: ActionTypes.FETCH_REJECTION_OPERATIONS,
});

const setRejectionOperations = ({ rejectionOperationsData }) => ({
  rejectionOperationsData,
  type: ActionTypes.SET_REJECTION_OPERATIONS,
});

const fetchOeesDates = ({ rejectionParams }) => ({
  rejectionParams,
  type: ActionTypes.FETCH_OEE_DATES,
});

const setOeesDates = ({ rejectionData }) => ({
  rejectionData,
  type: ActionTypes.SET_OEE_DATES,
});

const fetchOeesHours = ({ rejectionHoursParams }) => ({
  rejectionHoursParams,
  type: ActionTypes.FETCH_OEE_HOURS,
});

const setOeesHours = ({ rejectionHoursData }) => ({
  rejectionHoursData,
  type: ActionTypes.SET_OEE_HOURS,
});

const fetchOeesShifts = ({ rejectionShiftsParams }) => ({
  rejectionShiftsParams,
  type: ActionTypes.FETCH_OEE_SHIFTS,
});

const setOeesShifts = ({ rejectionShiftsData }) => ({
  rejectionShiftsData,
  type: ActionTypes.SET_OEE_SHIFTS,
});

const setRejectionOperationsLoaderStatus = ({ rejectionOperationsLoader }) => ({
  rejectionOperationsLoader,
  type: ActionTypes.SET_REJECTION_OPERATIONS_LOADER_STATUS,
});

const setJobRejectionConfirmationModaldData = ({ JobRejectionConfirmationModaldData = null }) => ({
  JobRejectionConfirmationModaldData,
  type: ActionTypes.SET_JOB_REJECTION_CONFIRMATION_MODAL_DATA,
});
const addUpdateRejectionOperation = ({ actionName, rejectionOperationObj, rejectionOperationsParams }) => ({
  actionName,
  rejectionOperationObj,
  rejectionOperationsParams,
  type: ActionTypes.ADD_UPDATE_REJECTION_OPERATION,
});

const addJobRejection = ({ rejectionData, jobGridParams }) => ({
  rejectionData,
  jobGridParams,
  type: ActionTypes.ADD_JOB_REJECTION,
});

const addJobHistoryRejection = ({ rejectionData, jobHistoryOperationParams }) => ({
  rejectionData,
  jobHistoryOperationParams,
  type: ActionTypes.ADD_JOB_HISTORY_REJECTION,
});

const addJobHistoryProduction = ({ productionData, jobHistoryOperationParams }) => ({
  productionData,
  jobHistoryOperationParams,
  type: ActionTypes.ADD_JOB_HISTORY_PRODUCTION,
});

const deleteRejectionOperation = ({ rejectionId, rejectionOperationsParams }) => ({
  rejectionId,
  rejectionOperationsParams,
  type: ActionTypes.DELETE_REJECTION_OPERATION,
});

const setRejectionFilter = ({ addRejection }) => ({
  addRejection,
  type: ActionTypes.SET_REJECTION_FILTER,
});

const fetchShiftRejection = ({ shiftRejectionParams }) => ({
  shiftRejectionParams,
  type: ActionTypes.FETCH_SHIFT_REJECTION,
});

const setShiftRejection = ({ shiftRejectionData, shiftRejectionParams, clear }) => ({
  shiftRejectionData,
  shiftRejectionParams,
  clear,
  type: ActionTypes.SET_SHIFT_REJECTION,
});

export default {
  fetchRejectionOperations,
  setRejectionOperationsLoaderStatus,
  setRejectionOperations,
  addUpdateRejectionOperation,
  deleteRejectionOperation,
  addJobRejection,
  addJobHistoryRejection,
  addJobHistoryProduction,
  setRejectionFilter,
  fetchOeesDates,
  setOeesDates,
  fetchOeesHours,
  setOeesHours,
  fetchOeesShifts,
  setOeesShifts,
  fetchShiftRejection,
  setShiftRejection,
  setJobRejectionConfirmationModaldData,
};
